const tap = (<any>window).tap || null;

const tapfiliate = (sale) => {
  if (!tap) return;

  const { customerId, transactionId, price, discount, promotionCode } = sale;

  // Uncomment this, to send the conversion to Tapfiliate
  // const amount = discount["discount"] ? discount?.amount : price.price;
  // const options = { coupons: [promotionCode], customer_id: customerId };

  // tap("conversion", transactionId, amount, options, null);

  tap("trial", customerId);
};

export { tapfiliate };
